import { Component, Inject } from '@angular/core';
import {
  AngularComponentInputs,
  FileSequenceInstance,
  FileSequenceTemplate,
} from 'app/types';

@Component({
  selector: 'app-file-sequence',
  templateUrl: './file-sequence-dialog.component.html',
  styleUrl: './file-sequence-dialog.component.scss',
})
export class FileSequenceComponent {
  fileSequenceSelectedOption: FileSequenceTemplate | null = null;
  startFileSequence: Function = () => {};

  readonly instancesMap: Map<number, FileSequenceInstance> = new Map();
  readonly templatesMap: Map<number, FileSequenceTemplate> = new Map();

  constructor(
    @Inject('INPUTS') public inputs: AngularComponentInputs,
    @Inject('OUTPUTS') public outputs: AngularComponentInputs,
  ) {
    this.startFileSequence = outputs.startFileSequence;
    this.instancesMap = inputs.instances.reduce(
      (
        map: Map<number, FileSequenceInstance>,
        instance: FileSequenceInstance,
      ) => {
        map.set(instance.file_sequence_template_id, instance);
        return map;
      },
      new Map(),
    );
    this.templatesMap = inputs.templates;
    if (this.templatesMap.size === 1) {
      this.fileSequenceSelectedOption =
        this.templatesMap.values().next().value ?? null;
    }
  }

  getOptions() {
    return [...this.templatesMap.values()].filter(
      (t: FileSequenceTemplate) => t.is_enabled && !this.instancesMap.has(t.id),
    );
  }
}
